import AppleSigninRaw from "react-apple-signin-auth";
import { useTranslation } from "react-i18next";
import { linkEGate } from "../helpers/eGateApi";
import React from "react";

const AppleSignin = (AppleSigninRaw as any).default || AppleSigninRaw;

interface AppleLoginProps {
  clientId: string;
}

// Apple Sign-in button styles
const appleSigninClasses = `
  [&_.apple-auth-btn]:!rounded-2xl [&_.apple-auth-btn]:!h-8
  [&_.apple-auth-btn]:!text-[rgb(60,64,67)] [&_.apple-auth-btn]:!border [&_.apple-auth-btn]:!border-[#dadce0]
  [&_.apple-auth-btn]:!text-sm [&_.apple-auth-btn]:!min-w-[196px]
`;

export function AppleSigninStyle({ children }: { children: React.ReactNode }) {
  return <div className={appleSigninClasses}>{children}</div>;
}

export default function AppleLogin(props: AppleLoginProps) {
  const { t } = useTranslation();

  const redirectUri = linkEGate("authorize/apple", null, "v2");

  return (
    <AppleSigninStyle>
      <AppleSignin
        authOptions={{
          clientId: props.clientId,
          nonce: "nonce",
          redirectURI: redirectUri,
          scope: "email name",
          state: "state",
          usePopup: false,
        }}
        buttonExtraChildren={t("Continue with Apple")}
        className="apple-auth-btn"
        noDefaultStyle={false}
        skipScript={false}
        uiType="light"
        onError={(error: any) => console.log(error)}
        onSuccess={(response: any) => console.log(response)}
      />
    </AppleSigninStyle>
  );
}
